var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticStyle:{"text-decoration":"none","color":"white"},attrs:{"target":"_blank","href":"https://fabricasistemas.com.br/"}},[_c('strong',[_vm._v(_vm._s(new Date().getFullYear())+" — Fábrica Sistemas")])])
}
var staticRenderFns = []

export { render, staticRenderFns }